/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_LanguageInputs */

const en_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adult Language`)
};

const fr_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langage adulte`)
};

const de_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erwachsenensprache`)
};

const it_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguaggio per adulti`)
};

const ru_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык взрослых`)
};

const es_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lenguaje adulto`)
};

const zh_cn2_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成人语言`)
};

const ja_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大人向けの言葉遣い`)
};

const hi_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वयस्क भाषा`)
};

const pt_pt2_subtitle_export_vchip_language = /** @type {(inputs: Subtitle_Export_Vchip_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguagem adulta`)
};

/**
* | output |
* | --- |
* | "Adult Language" |
*
* @param {Subtitle_Export_Vchip_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_language = /** @type {((inputs?: Subtitle_Export_Vchip_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_language(inputs)
	if (locale === "de") return de_subtitle_export_vchip_language(inputs)
	if (locale === "it") return it_subtitle_export_vchip_language(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_language(inputs)
	if (locale === "es") return es_subtitle_export_vchip_language(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_language(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_language(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_language(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_language(inputs)
	return en_subtitle_export_vchip_language(inputs)
});